import { render, staticRenderFns } from "./myInventoryDetailsModal.vue?vue&type=template&id=56fd9ec4"
import script from "./myInventoryDetailsModal.vue?vue&type=script&lang=js"
export * from "./myInventoryDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports